// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"d2ec1054","524":"1f0386a4","549":"26b97e14","745":"a58cfaf0","797":"a64d3fb2","880":"1903469c","945":"0716e936"}[chunkId] + ".chunk.js";
};